import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const SendReportDialog = ({ open, onOpenChange, managerEmail, comment, onCommentChange, onSubmit, sending }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="rounded-2xl">
      <DialogHeader><DialogTitle>Envoyer le rapport à {managerEmail}</DialogTitle></DialogHeader>
      <div className="space-y-3 mt-2">
        <div>
          <Label>Commentaire optionnel du manager</Label>
          <Textarea rows={3} value={comment} onChange={(e) => onCommentChange(e.target.value)} placeholder="Ex: Excellente semaine pour Marc, prévoyons un coaching pour Sophie..." className="rounded-xl mt-1" data-testid="report-comment" />
        </div>
        <Button onClick={onSubmit} disabled={sending} className="w-full rounded-full bg-emerald-500/100 hover:bg-emerald-500" data-testid="confirm-send-report">
          {sending ? "Envoi..." : "Envoyer"}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
